import Dialog from './Dialog';
import LogsCard from '../general/LogsCard';
import { en } from '../../locales/en';
import { useGcsStore } from '../../store/useGcsStore';
import { getServerNameCode } from '../../config/gcs/gcsConfigs';

interface UssLogsDialogProps {
  gcsId: string;
  onClose: () => void;
}

function UssLogsDialog({ gcsId, onClose }: UssLogsDialogProps) {
  const ussLogs = useGcsStore((state) => {
    const gcsData = state.data.get(gcsId);
    return gcsData?.ussLogs || [];
  });

  const nameCode = getServerNameCode(gcsId);

  return (
    <Dialog title={en.ussLogsDialog.title} onClose={onClose}>
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <LogsCard title={nameCode} logs={ussLogs} height='400px' />
      </div>
    </Dialog>
  );
}

export default UssLogsDialog;
